
// import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import Button from "react-bootstrap/Button";
import { IoReorderThree } from "react-icons/io5";
import Sidebar from "../../Components/Sidebar"
import DeleteModal from "../../Components/Modal/Deletemodal";
import CreateTemplateModal from "../../Components/Modal/CreateTemplateModal";
import { useEffect, useState } from "react";
import DeleteNotification from "../../Components/Notification/DeleteNotification";
import OrganizationTable from "../../Components/Table/OrganizationTable";
import { useSelector } from "react-redux";
import { GetMyOrganizationUser } from "../../redux/actions/myorganization.action";
import { getUser } from "../../redux/actions/authAction";
import { getTemplate, deleteTemplate } from "../../redux/actions/templateaction";


const MyOrganization = () => {

    const [deletenotificationmodal, setDeleteNotificationmodal] = useState(false)
    const [modalVisible, setModalVisible] = useState(false)
    const [templateModalVisible, setTemplateModalVisible] = useState(false)
    const [, setchecked] = useState(false)
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const organizationid = localStorage.getItem('organizationid');
    const currentUser = useSelector((state) => state?.Auth?.userDetails?.user)
    const canManageTemplates = currentUser?.canManageTemplates !== false

    useEffect(() => {
        const fetchData = async () => {
            try {
                let myorganizationpayload = { organization_ids: [organizationid] }
                await getUser(organizationid);
                await GetMyOrganizationUser(myorganizationpayload)
                await getTemplate({ organizationid, page: 1 })

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData(); // Call the fetchData function

    }, [organizationid]);
    const AllMyOrganzationUsers = useSelector((state) => state?.myorganizationReducers?.AllMyOrganzationUsers)
    const templates = useSelector((state) => state?.Templatereducer?.AllTemplate?.template) || []

    const refreshTemplates = async () => {
        try {
            await getTemplate({ organizationid, page: 1 })
        } catch (error) {
            console.error('Error refreshing templates:', error)
        }
    }

    return (

        <>

            <div className="dashboard">
            <Sidebar show={show} setShow={setShow} />
                <div className="dashboard-right-side">
                    <div className="headerbox">
                        <div className="d-flex gap-2 align-items-center">
                            <Button className="d-block d-lg-none bg-transparent text-dark border border-0" onClick={handleShow}>
                                <IoReorderThree size={30} />
                            </Button>
                            <div className="headertext">My Organization</div>
                        </div>


                    </div>




                    <div className="phisingcampaigns">

                        <div className="mainheadingdiv">

                            <div style={{ width: '80%' }}>
                            </div>

                            <div className="searchbox">

                                {/* <Search placeholder="Search user...." onSearch={onSearch} enterButton /> */}
                            </div>

                        </div>



                        <OrganizationTable
                            Individualuser={AllMyOrganzationUsers?.data?.members}
                            setchecked={setchecked}
                        />


                    </div>


                    <div className="phisingcampaigns" style={{ marginTop: '24px' }}>
                        <div className="mainheadingdiv" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <p className="organization-para" style={{ marginBottom: 0 }}>Templates</p>
                                <p style={{ fontSize: '12px', color: '#6b7280', marginBottom: 0 }}>
                                    Reusable SMS message templates for your campaigns.
                                </p>
                            </div>
                            {canManageTemplates && (
                                <Button
                                    onClick={() => setTemplateModalVisible(true)}
                                    style={{ backgroundColor: '#2563eb', borderColor: '#2563eb', color: '#fff' }}
                                >
                                    Create Template
                                </Button>
                            )}
                        </div>

                        <div style={{ marginTop: '12px' }}>
                            {templates.length > 0 ? (
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    {templates.map((t) => (
                                        <li
                                            key={t._id}
                                            style={{
                                                padding: '10px 12px',
                                                borderBottom: '1px solid #e5e7eb',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                gap: '12px',
                                            }}
                                        >
                                            <span style={{ fontWeight: 500, flexShrink: 0 }}>{t.name || 'Untitled'}</span>
                                            <span style={{ color: '#6b7280', fontSize: '12px', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {t.message}
                                            </span>
                                            {canManageTemplates && (
                                                <Button
                                                    size="sm"
                                                    onClick={async () => {
                                                        if (window.confirm(`Delete template "${t.name || 'Untitled'}"? This cannot be undone.`)) {
                                                            await deleteTemplate({ id: t._id, organizationid })
                                                        }
                                                    }}
                                                    style={{ backgroundColor: '#dc2626', borderColor: '#dc2626', color: '#fff', flexShrink: 0 }}
                                                >
                                                    Delete
                                                </Button>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p style={{ color: '#6b7280', fontSize: '14px', marginTop: '8px' }}>
                                    {canManageTemplates
                                        ? 'No templates yet. Click "Create Template" to add your first one.'
                                        : 'No templates available. Contact an administrator to enable template management for your account.'}
                                </p>
                            )}
                        </div>
                    </div>


                </div>
            </div>


            <DeleteModal
                visible={modalVisible}
                onClose={() => setModalVisible(false)}
                //    currentRoute={}
                setNotificationmodal={setDeleteNotificationmodal}
            />

            <DeleteNotification
                visible={deletenotificationmodal}
                onClose={() => setDeleteNotificationmodal(false)}

            />

            <CreateTemplateModal
                visible={templateModalVisible}
                onClose={() => {
                    setTemplateModalVisible(false)
                    refreshTemplates()
                }}
                organizationid={organizationid}
            />

        </>
    )
}

export default MyOrganization;
